function normalizeProvider(domainLike) {
  const raw = String(
    domainLike?.relayProvider ||
    domainLike?.authProvider ||
      domainLike?.dkimProvider ||
      domainLike?.spfProvider ||
      ''
  )
    .trim()
    .toLowerCase();

  if (raw === 'smtpcom') return 'smtp_com';
  if (raw === 'twilio' || raw === 'twilio_sendgrid') return 'sendgrid';
  if (raw === 'elasticemail') return 'elastic_email';
  return raw
    .replace(/-/g, '_')
    .replace(/[^a-z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
}

function safeTrim(value) {
  return String(value || '').trim();
}

function accountSuffix(identifier) {
  const raw = safeTrim(identifier);
  if (!raw) return '';

  const digits = raw.replace(/\D/g, '');
  if (digits.length >= 4) return digits.slice(-4);
  return '';
}

function formatEndingSuffix(identifier) {
  const suffix = accountSuffix(identifier);
  return suffix || '';
}

function formatProviderName(provider) {
  const normalized = normalizeProvider({ relayProvider: provider });
  if (!normalized) return '';
  if (normalized === 'smtp_com') return 'SMTP.com';
  if (normalized === 'mailchannels') return 'MailChannels';
  if (normalized === 'mailgun') return 'Mailgun';
  if (normalized === 'sendgrid') return 'Twilio SendGrid';
  if (normalized === 'elastic_email') return 'Elastic Email';
  return normalized
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}

export function getRelayAccountLabel(domainLike) {
  if (!domainLike) return '';

  const explicitLabel = safeTrim(domainLike.relayAccountLabel);
  if (explicitLabel) return explicitLabel;

  const provider = normalizeProvider(domainLike);
  if (!provider) return '';
  const providerName = formatProviderName(provider);

  const explicitSuffix = safeTrim(
    domainLike.relayAccountSuffix ||
      (domainLike.relayAccountSuffixOverrides && domainLike.relayAccountSuffixOverrides[provider]) ||
      ''
  );
  if (/^[A-Za-z0-9]{4}$/.test(explicitSuffix)) {
    return `${providerName} ${explicitSuffix}`;
  }

  const identifier = safeTrim(
    domainLike.relayAccountIdentifier ||
      domainLike.smtpRelayChannel ||
      domainLike.mailgunRelayUsername ||
      domainLike.mailchannelsAuthId ||
      domainLike.channel ||
      domainLike.username
  );

  if (identifier) {
    const ending = formatEndingSuffix(identifier);
    return ending ? `${providerName} ${ending}` : providerName;
  }

  if (provider === 'mailgun') {
    const selector = safeTrim(domainLike.mailgunDkimSelector);
    if (selector) {
      const ending = formatEndingSuffix(selector);
      return ending ? `${providerName} ${ending}` : providerName;
    }
  }

  return providerName;
}

export function getDomainPickerLabel(domainLike) {
  const domainName = safeTrim(domainLike?.domain || domainLike);
  if (!domainName) return '';
  const relayLabel = getRelayAccountLabel(domainLike);
  return relayLabel ? `${domainName} - ${relayLabel}` : domainName;
}
